'use client'

import { ReactNode } from 'react'

import { ClientDataComponentIdentifier } from './types'
import useClientDataComponentContext from './useClientDataComponentContext'

type Props = {
  className?: string
  id: ClientDataComponentIdentifier
  fallback: ReactNode
}

const ClientDataComponentSlot = ({ id, fallback, className }: Props) => {
  const { setElement, isFallbackShown } = useClientDataComponentContext(id)

  return (
    <div className={className} ref={setElement}>
      {isFallbackShown && fallback}
    </div>
  )
}

export default ClientDataComponentSlot
